import React, { FC, ReactNode } from "react";

import { UnreadMark, Avatar, Link, Icon } from "~/components/atoms";

import {
  DeliveryEventNotificationHistoryPostableTypeColorMapping,
  DeliveryEventNotificationHistoryType,
} from "~/domains";

type WrapperPropsType = {
  item: DeliveryEventNotificationHistoryType;
  className?: string;
  children: ReactNode;
};

export const ButtonWithDeliveryNotificationItemWrapper: FC<
  WrapperPropsType
> = ({ item, className = "", children }: WrapperPropsType) => {
  const postable =
    DeliveryEventNotificationHistoryPostableTypeColorMapping[item.postableType];
  return postable.link ? (
    <Link
      key={item.id}
      to={`${postable.link}/${item.postableId}`}
      className={`
        flex py-5 px-4 space-x-4 
        border-b border-secondary-300 
        ${
          !item.readAt
            ? "bg-gradient-to-r from-primary-50 to-calendar-50 border-l-4 border-l-primary-400"
            : "bg-white"
        }
        hover:bg-gradient-to-r hover:from-primary-200 hover:to-secondary-100
        hover:shadow-lg hover:shadow-primary-300/40
        transition-all duration-300 ease-out
        cursor-pointer
        ${!item.readAt ? "animate-pulse" : ""}
        ${className}
      `}
    >
      {children}
    </Link>
  ) : (
    <div
      key={item.id}
      className={`
        flex py-5 px-4 space-x-4 
        border-b border-secondary-300 
        ${
          !item.readAt
            ? "bg-gradient-to-r from-primary-50 to-calendar-50 border-l-4 border-l-primary-400"
            : "bg-white"
        }
        hover:bg-gradient-to-r hover:from-primary-200 hover:to-secondary-100
        hover:shadow-lg hover:shadow-primary-300/40
        transition-all duration-300 ease-out
        cursor-pointer
        ${!item.readAt ? "animate-pulse" : ""}
        ${className}
      `}
    >
      {children}
    </div>
  );
};

type PropsType = {
  item: DeliveryEventNotificationHistoryType;
  className?: string;
};
export const ButtonWithDeliveryNotificationItem: FC<PropsType> = ({
  item,
  className = "",
}: PropsType) => {
  const postable =
    DeliveryEventNotificationHistoryPostableTypeColorMapping[item.postableType];
  return (
    <ButtonWithDeliveryNotificationItemWrapper
      item={item}
      className={className}
    >
      <div className="flex-shrink-0 relative group">
        <div className="relative ring-2 ring-transparent group-hover:ring-primary-300 rounded-full transition-all duration-300">
          <Avatar
            src={item.sender.avatarUrl}
            className={`${postable?.className} shadow-lg`}
            size={"md"}
          />
          {!item.readAt && <UnreadMark />}
        </div>
      </div>
      <div className="flex-1 min-w-0">
        <div className="flex items-start justify-between mb-2 gap-2 miniTablet:flex-row flex-col">
          <span className="inline-flex items-center miniTablet:px-3 px-2 py-1 rounded-full text-xs miniTablet:text-sm font-medium bg-gradient-to-r from-primary-600 to-calendar-800 text-white shadow-sm">
            {item.jaPostableTypeName}
          </span>
          <span className="flex items-center text-xs text-secondary-600 bg-secondary-100 miniTablet:px-2 px-1 py-1 rounded-md">
            <Icon icon="ioTimeOutline" size="1rem" className="mr-1" />
            {item.createdAt}
          </span>
        </div>
        <h3 className="text-base text-secondary-600 line-clamp-2 leading-relaxed mb-1 hover:text-primary-600 transition-colors duration-200">
          {item.title}
        </h3>
      </div>
    </ButtonWithDeliveryNotificationItemWrapper>
  );
};
